'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var script = require('scriptjs');

script('https://platform.twitter.com/widgets.js', 'twitter-embed');

var TwitterOnAirButton = function (_Component) {
  (0, _inherits3.default)(TwitterOnAirButton, _Component);

  function TwitterOnAirButton() {
    (0, _classCallCheck3.default)(this, TwitterOnAirButton);
    return (0, _possibleConstructorReturn3.default)(this, (TwitterOnAirButton.__proto__ || (0, _getPrototypeOf2.default)(TwitterOnAirButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(TwitterOnAirButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      script.ready('twitter-embed', function () {
        if (!window.twttr) {
          console.error('Failure to load window.twttr, aborting load.');
          return;
        }

        if (!_this2.isMountCanceled) {
          window.twttr.widgets.createPeriscopeOnAirButton(_this2.props.username, _this2.refs.embedContainer, _this2.props.options);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isMountCanceled = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { ref: 'embedContainer' });
    }
  }]);
  return TwitterOnAirButton;
}(_react.Component);

TwitterOnAirButton.propTypes = {
  /**
   * Username for which you require periscope on air button
   */
  username: _propTypes2.default.string.isRequired,
  /**
   * Additional options for overriding config.
   */
  options: _propTypes2.default.object
};
exports.default = TwitterOnAirButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-twitter-embed/dist/components/TwitterOnAirButton.js
// module id = 399
// module chunks = 0